import { isNonEmpty } from "@Helpers/numberCondition";
import axiosWrapper from "@AxiosWrapper";
import * as Sentry from "@Sentry";

export const SignTypeValues = {
  TYPE_NAME_INITIAL: "TYPE_NAME_INITIAL",
  DRAW_ON_SCREEN: "DRAW_ON_SCREEN",
  IMPORT_AS_IMAGE: "IMPORT_AS_IMAGE",
  EMBED_INSIDE_FILE: "EMBED_INSIDE_FILE",
  ATTACH_SIGNED_DOCUMENT: "ATTACH_SIGNED_DOCUMENT",
  IMPORT_PROFILE_SIGNATURE: "IMPORT_PROFILE_SIGNATURE",
};

export const SignTypes = [
  {
    name: "Draw On Screen",
    value: SignTypeValues.DRAW_ON_SCREEN,
  },
  {
    name: "Attach Signed Document",
    value: SignTypeValues.ATTACH_SIGNED_DOCUMENT,
  },
  {
    name: "Import Profile Signature",
    value: SignTypeValues.IMPORT_PROFILE_SIGNATURE,
  },
];
// The three id sources a schedule task can carry, in priority order.
/** The id-bearing fields this looks for; callers hand over whole task/activity rows, none of
 * which declare all three, so the parameter stays `object` and each read is asserted. */
type TaskIdFields = { WBSCode?: string; customTaskId?: string; scheduleCounter?: number | string };

export const getTaskId = (taskData?: object) => {
  let taskId;
  if ((taskData as TaskIdFields | undefined)?.WBSCode) {
    taskId = `${(taskData as TaskIdFields | undefined)?.WBSCode}`;
  } else if ((taskData as TaskIdFields | undefined)?.customTaskId) {
    taskId = `${(taskData as TaskIdFields | undefined)?.customTaskId}`;
  } else {
    const counter = (taskData as TaskIdFields | undefined)?.scheduleCounter ?? "0";
    taskId = `TSK-${String(counter).padStart(4, "0")}`;
  }
  return taskId;
};

/**
 * `data.id` is `?: string | undefined`, not `?: string`. Callers pass rows whose `id` is an optional
 * member read straight off a document, so the key is PRESENT holding `undefined` — under
 * `exactOptionalPropertyTypes` the bare `?: string` form rejects that at all 13 call sites. The
 * function already handles the missing case explicitly below (it reports to Sentry and returns "").
 * NOTE: this widening was lost once already, in the `rke2-staging` merge on 2026-09-03, which
 * resolved the conflict by taking the incoming side and silently reverted it. Keep both this and the
 * `version` cache-buster parameter — they came from different branches and neither replaces the other.
 */
export const getUrlForImage = (
  data: { id?: string | undefined } | null | undefined,
  type = "profile",
  version?: string | number | null,
) => {
  const id = data?.id;
  if (!id || id === "undefined" || id === "null") {
    Sentry.captureException(new Error(`getUrlForImage called without a valid id (type: ${type}, id: ${id})`));
    return "";
  }
  return axiosWrapper.api.url("/fileSystemServer/getImage/:type/:id", {
    pathParams: { type, id },
    params: isNonEmpty(version) ? { v: version } : {},
  });
};

export const defaultFeedbackToastComponentProps = {
  position: {
    X: "Right",
    Y: "Bottom",
  },
  timeOut: 3000,
  width: 400,
  content: "<div>Your message has been <b>sent</b> successful.</div>",
  title: "",
  isActionButton: false,
  actionBtnText: "UNDO",
};
